import {
  Column,
  GridContainer,
  Li,
  Row,
  Span,
  Ul,
  useScreenClass,
} from '@vp/swan';
import { DateFormatTypes } from '@vp/om-date-formatter';
import React from 'react';
import { useTranslations } from '@vp/om-translations';
import Currency, { Price } from './Currency';
import useSiteData from '../../hooks/useSiteData';
import Date from './Date';

const defaultOrderDisplayPrice = {
  centAmount: 0,
  currencyCode: '',
  fractionDigits: 0,
};

type OrderInfoDisplayProps = {
  orderNumber: string;
  orderCreationDate: string;
  orderDisplayPrice?: Price;
};

export const OrderInfoDisplay = ({
  orderNumber,
  orderCreationDate,
  orderDisplayPrice = defaultOrderDisplayPrice,
}: OrderInfoDisplayProps) => {
  const [orderDetailsMessages, orderSummaryMessages] = useTranslations([
    'orderDetailsMessages',
    'orderSummaryMessages',
  ]);
  const { locale } = useSiteData();
  const screenClass = useScreenClass();

  const showOrderTotal = orderDisplayPrice.currencyCode !== '';

  return (
    <GridContainer>
      <Row>
        <Column span={12} mb={screenClass === 'xs' ? 5 : 6}>
          <Ul skin="minimal">
            <Li py={2} key={`order-number-${orderNumber}`}>
              <Span fontWeight="bold">
                {`${orderDetailsMessages.orderNumberField}: `}
              </Span>
              <Span>{orderNumber}</Span>
            </Li>
            <Li py={2} key={`order-date-${orderNumber}`}>
              <Span fontWeight="bold">
                {`${orderDetailsMessages.orderDateField}: `}
              </Span>{' '}
              <Span>
                <Date
                  date={orderCreationDate}
                  dateFormatType={DateFormatTypes.MEDIUM_FMT}
                />
              </Span>
            </Li>
            {showOrderTotal ? (
              <Li py={2} key={`order-total-${orderNumber}`}>
                <Span fontWeight="bold">
                  {`${orderSummaryMessages.totalPaidField}: `}
                </Span>
                <Span>
                  <Currency
                    price={orderDisplayPrice}
                    locale={locale}
                    currency={orderDisplayPrice.currencyCode}
                  />
                </Span>
              </Li>
            ) : null}
          </Ul>
        </Column>
      </Row>
    </GridContainer>
  );
};
